const remix_steps = [
    {
        title: "Pasos para crear y desplegar tu contrato en Remix IDE (Polygon Testnet)",
        value: `
  Aquí tienes un repaso visual y práctico de todos los pasos necesarios para crear, editar, compilar y desplegar tu contrato inteligente en Remix IDE sobre Polygon (testnet Amoy o Mumbai). Sigue cada paso con la imagen correspondiente para no perderte en el proceso.
  
  ---
  
  **1. Abrir Remix IDE**  
  Accede al entorno de desarrollo Remix en [remix.ethereum.org](https://remix.ethereum.org) desde tu navegador. Es una plataforma en línea para escribir, compilar y desplegar contratos inteligentes en Solidity.  
  ![Abrir Remix](https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/19-1.png)
  
  ---

   **2. Crear nuevo archivo en Remix IDE**  
    Al abrir Remix IDE, puede aparecer una ventana emergente pidiéndote aceptar o rechazar la recopilación de datos anónimos para mejorar la plataforma (por Matomo).
    Puedes hacer clic en Accept para ayudar al desarrollo, o en Decline para continuar sin compartir información.
    Una vez que cierres este mensaje, verás la interfaz principal de Remix, donde podrás empezar a crear tu contrato.

![Crear archivo](https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/19-2.png)
  
  ---

  **3. Seleccionar el propósito de uso en Remix IDE**  
  Al iniciar Remix IDE, aparece una ventana de bienvenida donde puedes seleccionar el propósito principal de tu uso.  
Elige la opción que mejor se adapte a tus necesidades:

- **Learning** – discovering web3 development
- **Prototyping** – trying out concepts and techniques
- **Developing projects** – Remix as your main dev tool
- **Production** – only deployments

Esto ayuda a Remix a personalizar tu experiencia, pero puedes cambiarlo más adelante en la configuración si lo deseas.

  ![Nombrar archivo](https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/19-3.png)
  
  ---
  
**4. Crear un archivo en Remix IDE**  
Haz clic en el botón “Create Using Template” en el menú del explorador de archivos, ubicado en la parte superior izquierda.  
Selecciona “Create Using Template” para iniciar un nuevo archivo dentro de la carpeta \`contracts\`. Así podrás comenzar a escribir el código de tu contrato inteligente.  
![Crear archivo en Remix](https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/19-4.png)

**5. Seleccionar plantilla para tu contrato**  
Después de crear el archivo, Remix te muestra varias plantillas disponibles para iniciar tu proyecto.  
Puedes elegir una plantilla básica (“BASIC” o “BLANK”) o directamente la de “ERC20” en la sección OpenZeppelin si quieres un contrato de token fungible personalizable.  
Haz clic en el botón **Create** de la plantilla que prefieras para añadirla a tu espacio de trabajo.  
![Seleccionar plantilla](https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/19-5.png)

  ---
  
  **6. Ver los contratos de ejemplo al seleccionar una plantilla**  
  Después de elegir una plantilla como **BASIC** y hacer clic en **Create**, Remix automáticamente agrega uno o más contratos de ejemplo en la carpeta \`contracts\`.  
Esto te permite ver y modificar el código base que viene incluido con la plantilla seleccionada.  
En la imagen puedes ver ejemplos de contratos como \`1_Storage.sol\`, \`2_Owner.sol\` y \`3_Ballot.sol\` dentro de la carpeta \`contracts\`.  
  ![Escribir código](https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/19-6.png)
  
  ---

**7. rear un nuevo archivo de contrato en la carpeta contracts**  
  Con la carpeta \`contracts\` abierta y seleccionada, haz clic en el ícono de **“Crear nuevo archivo”** (el símbolo de hoja con un “+”) en la parte superior del explorador de archivos.  
Esto abrirá un campo donde puedes **escribir el nombre de tu archivo**.  
Asigna un nombre descriptivo, por ejemplo: \`RealStateToken.sol\`.  
Así defines el archivo donde escribirás el código de tu contrato inteligente.    
  ![Constructor](https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/19-7a.png)
  
  ---
 **8. El contrato ya ha sido creado y aparece en el editor**  
  Una vez que creas y nombras tu nuevo archivo (por ejemplo, \`RealEstateToken.sol\`), el archivo aparece dentro de la carpeta \`contracts\` en el panel izquierdo y se abre automáticamente en el editor central.

- El **nombre del archivo** también se muestra en la pestaña superior del editor, facilitando la navegación entre varios archivos.
- El archivo se muestra en **color naranja** porque ha sido **modificado** o aún no ha sido guardado después de realizar algún cambio. Remix usa este color para indicar archivos con cambios pendientes.

Puedes comenzar a **escribir el código de tu contrato** directamente en el área central del editor. 
  ![Compilador](https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/19-8.png)
  

  ---
  
  **9.Copia y pega el código de tu contrato en Remix IDE**  
  Después de editar y personalizar el código de tu contrato en un editor externo como **Sublime Text**,  
copia todo el código y pégalo en el archivo que creaste en Remix IDE (por ejemplo, \`RealEstateToken.sol\`).  

Esto te permite trabajar de forma cómoda y aprovechar las herramientas de Remix para compilar, desplegar y verificar tu contrato inteligente en la blockchain.

En la imagen puedes ver el contrato pegado y listo para compilar en Remix IDE.  
  ![Seleccionar versión](https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/19-9.png)
  

---
**10. Selecciona la versión correcta del compilador en Remix IDE**  
  Antes de compilar tu contrato, es fundamental que elijas la **versión del compilador Solidity** que corresponde con la versión declarada en tu contrato (por ejemplo, \`pragma solidity ^0.8.0;\`).  
Esto asegura que el código se compile correctamente y previene errores de incompatibilidad.

**¿Por qué es importante la versión?**
- Cada versión de Solidity puede introducir cambios y nuevas funciones.  
- Si el compilador es demasiado antiguo o demasiado nuevo respecto al pragma de tu contrato, pueden surgir errores o advertencias.
- Usar la versión correcta garantiza que todas las instrucciones de tu contrato se interpreten como esperas.

**¿Cómo seleccionarla?**
1. Ve al panel lateral izquierdo y haz clic en el icono del **compilador** (el engranaje o símbolo de Solidity).
2. En la sección “COMPILER”, elige la versión que coincida (o sea compatible) con tu contrato.
   - Por ejemplo, si tienes \`pragma solidity ^0.8.0;\`, puedes elegir cualquiera desde 0.8.0 en adelante, pero es recomendable la más reciente dentro de la misma familia (por ejemplo, 0.8.30).
3. Espera a que Remix descargue y seleccione esa versión; verás una marca verde cuando esté lista.

![Compilar contrato](https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/19-12.png)

Una vez seleccionada la versión adecuada, ya puedes proceder a compilar tu contrato.

  ![Compilar contrato](https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/19-13.png)
  




  ---
  
  **11. Compilar el contrato en Remix IDE**  
   El siguiente paso es **compilar el contrato** para asegurarte de que no haya errores de sintaxis ni problemas en el código.

1. Dirígete al panel lateral izquierdo y haz clic en el **icono del compilador** (generalmente tiene un símbolo de Solidity \`<S>\` o de engranaje).
2. Verifica que el archivo \`RealEstateToken.sol\` esté seleccionado.
3. Haz clic en el botón **'Compile RealEstateToken.sol'**.  
   ![Compilar contrato](https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/19-10a.png)

**¿Qué sucede después?**
- Si la compilación es exitosa, verás un mensaje indicando que el contrato fue compilado correctamente.
- Si hay errores, Remix mostrará los mensajes de error en la parte inferior de la pantalla, indicando el número de línea y la descripción del problema.
- Corrige cualquier error señalado y vuelve a presionar el botón de compilación hasta que no haya advertencias ni errores.


**Otra forma de compular con los pasos detallados :**

1. Asegúrate de tener abierto el archivo de tu contrato (por ejemplo, \`RealEstateToken.sol\`).
2. En el panel lateral izquierdo, bajo el ícono del compilador, verifica que el campo "COMPILER" tenga la versión correcta seleccionada.
3. Aparecerá el botón azul **"Compile RealEstateToken.sol"**. Haz clic en este botón para iniciar la compilación.
4. Si todo está correcto, el contrato se compilará y verás que aparecen nuevas opciones abajo, como **ABI**, **Bytecode** y análisis del contrato.

**¿Qué sucede si hay errores?**
- Si existen errores de sintaxis o advertencias, Remix los mostrará en la parte inferior de la pantalla, indicando el número de línea y la causa.
- Corrige los errores y vuelve a hacer clic en el botón de compilación hasta que desaparezcan.
  ![Compilar contrato](https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/19-14.png)
  
  ---
  
  **12.  Archivos generados después de compilar correctamente en Remix IDE**  
  Cuando la compilación de tu contrato es **exitosa**, Remix IDE genera automáticamente una serie de archivos nuevos dentro de la carpeta \`artifacts/build-info\` y en la raíz de la carpeta \`contracts\`. Estos archivos son fundamentales para desplegar y verificar tu contrato en la blockchain.

**¿Qué archivos aparecen y para qué sirven?**

- **Archivos \`.json\` en \`contracts\`:**
  - Por cada contrato compilado (por ejemplo, \`RealEstateToken.sol\`), se generan archivos \`.json\` con información detallada del contrato, incluyendo su ABI (Application Binary Interface) y Bytecode.
  - Ejemplo: \`RealEstateToken_metadata.json\`, \`RealEstateToken.json\`.

- **Carpeta \`artifacts/build-info\`:**
  - Aquí se guarda información técnica sobre la compilación, útil para herramientas de verificación y análisis avanzado.

**¿Para qué sirven estos archivos?**
- El **ABI** es necesario para interactuar con el contrato desde interfaces, dApps o scripts.
- El **Bytecode** es lo que se despliega en la blockchain.
- Los metadatos ayudan a verificar y auditar el contrato en plataformas como Etherscan.

En la imagen puedes ver cómo aparecen estos archivos después de compilar correctamente tu contrato en Remix IDE.
  
  ![ABI y bytecode](https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/19-11.png)
  
---
   **13. El contrato está listo para desplegarse en la red de tu elecció**  
 Una vez que el contrato ha sido **compilado correctamente** y verificas que no hay errores, significa que ya está **listo para ser desplegado** en una red blockchain.

**¿A qué red puedes desplegar tu contrato?**
- Puedes elegir una **red de pruebas (testnet)** como **Sepolia** o **Amoy**.  
  Estas redes simulan el comportamiento de la red principal, pero sin poner en riesgo fondos reales, ideal para hacer pruebas y aprender el proceso completo de despliegue.
- También puedes desplegar tu contrato en la **mainnet** (red principal), pero solo después de probar todo a fondo y estar seguro de que el código funciona perfectamente.

**¿Qué sigue después de compilar?**
1. Prepara tu wallet y fondos de prueba (ETH para Sepolia, MATIC para Amoy, etc.).
2. Selecciona la red deseada en el entorno de despliegue de Remix IDE.
3. Ahora puedes continuar con el proceso para **desplegar tu contrato** y verlo en funcionamiento real.

> **Tip:** Siempre se recomienda desplegar primero en una testnet como Sepolia o Amoy para asegurarte de que todo funciona correctamente antes de ir a la mainnet.
  `
    }
];

export default remix_steps;